const HASH = '#sdc-offcanvas';
const ORIGIN = 'https://ext.matool.de';
const SCROLL_SIGNAL = 99999999;

function isOffcanvasLink(link) {
  if (link.classList.contains('sdc-offcanvas')) {
    return true;
  }

  if (link.closest('.sdc-offcanvas')) {
    return true;
  }

  return link.hash === HASH;
}

function isSameDocumentHash(link) {
  if (link.hash !== HASH) {
    return false;
  }

  const url = new URL(link.href, window.location.href);

  return url.origin === window.location.origin && url.pathname === window.location.pathname;
}

function readFrameHeight(data) {
  if (typeof data === 'number' && Number.isInteger(data)) {
    return data;
  }

  if (typeof data === 'string' && /^\d+$/.test(data)) {
    return Number(data);
  }

  return null;
}

export function initOffcanvas() {
  const dialog = document.getElementById('sdc-offcanvas');

  if (!(dialog instanceof HTMLDialogElement)) {
    return;
  }

  const iframe = dialog.querySelector('#probeForm');

  if (!(iframe instanceof HTMLIFrameElement)) {
    return;
  }

  let returnFocus = null;

  const ensureSrc = () => {
    const src = iframe.dataset.src ?? '';

    if (src === '' || iframe.getAttribute('src') !== null) {
      return;
    }

    iframe.src = src;
  };

  const open = (trigger) => {
    ensureSrc();
    returnFocus = trigger;
    if (!dialog.open) {
      dialog.showModal();
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const closeButton = event.target.closest('[data-sdc-close]');

    if (closeButton && dialog.contains(closeButton)) {
      event.preventDefault();
      dialog.close();
      return;
    }

    const link = event.target.closest('a');

    if (!(link instanceof HTMLAnchorElement) || dialog.contains(link) || !isOffcanvasLink(link)) {
      return;
    }

    const classTrigger = link.classList.contains('sdc-offcanvas') || Boolean(link.closest('.sdc-offcanvas'));

    if (!classTrigger && !isSameDocumentHash(link)) {
      return;
    }

    event.preventDefault();
    open(link);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', () => {
    returnFocus?.focus();
    returnFocus = null;
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== ORIGIN || event.source !== iframe.contentWindow) {
      return;
    }

    const height = readFrameHeight(event.data);

    if (height === null || height <= 0 || height === SCROLL_SIGNAL) {
      return;
    }

    iframe.style.height = `${height}px`;
  });

  if (window.location.hash === HASH) {
    open(null);
  }
}

initOffcanvas();
